import { apiClient } from './client';
import { ImpersonationExchangeResponse } from '../types';

export const impersonationExchange = async (
  code: string
): Promise<ImpersonationExchangeResponse> => {
  const response = await apiClient.post<ImpersonationExchangeResponse>(
    '/v1/auth/impersonation-exchange',
    { code }
  );
  return response.data;
};
